import { render, staticRenderFns } from "./Bikes.vue?vue&type=template&id=55bb7570&"
import script from "./Bikes.vue?vue&type=script&lang=js&"
export * from "./Bikes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Bikes.vue"
export default component.exports